import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as empresasApi from '../../api/empresas';
import PageHeader from '../../components/common/PageHeader';
import StatusBadge from '../../components/common/StatusBadge';
import EmptyState from '../../components/common/EmptyState';
import Skeleton from '../../components/common/Skeleton';
import { usePaginacao } from '../../hooks/usePaginacao';
import { useSortable } from '../../hooks/useSortable';

export default function Empresas() {
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [erro, setErro] = useState('');

  useEffect(() => {
    empresasApi
      .listEmpresas()
      .then((r) => setItens(r.data))
      .catch(() => setErro('Erro ao carregar empresas.'))
      .finally(() => setLoading(false));
  }, []);

  const filtrados = itens.filter((i) => i.nome.toLowerCase().includes(busca.toLowerCase()));
  const { sorted, Th } = useSortable(filtrados, 'nome');
  const { paginados, Paginacao } = usePaginacao(sorted);

  return (
    <div>
      <PageHeader titulo="Empresas" subtitulo="Distribuidoras cadastradas na plataforma" acaoLabel="Nova empresa" acaoTo="/empresas/novo" />

      {erro && (
        <div className="sf-login-alert mb-3">
          <i className="bi bi-exclamation-circle" />
          {erro}
        </div>
      )}

      <div className="sf-table-card">
        <div className="sf-table-toolbar">
          <div className="sf-search">
            <i className="bi bi-search" />
            <input placeholder="Buscar por nome..." value={busca} onChange={(e) => setBusca(e.target.value)} />
          </div>
        </div>

        {loading ? (
          <div className="p-4">
            <Skeleton linhas={5} />
          </div>
        ) : paginados.length === 0 ? (
          <EmptyState icon="bi-building" titulo="Nenhuma empresa cadastrada" texto="Cadastre a primeira distribuidora da plataforma." acaoLabel="Nova empresa" acaoTo="/empresas/novo" />
        ) : (
          <>
            <div className="table-responsive">
              <table className="sf-table">
                <thead>
                  <tr>
                    <Th campo="nome">Nome</Th>
                    <th>CNPJ</th>
                    <th>Status</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {paginados.map((e) => (
                    <tr key={e.id_empresa}>
                      <td>
                        <span className="d-flex align-items-center gap-2">
                          <span className="sf-cell-icon"><i className="bi bi-building" /></span>
                          <span className="sf-cell-title">{e.nome}</span>
                        </span>
                      </td>
                      <td>{e.cnpj || '—'}</td>
                      <td><StatusBadge status={e.ativo ? 'ativo' : 'inativo'} /></td>
                      <td className="text-end">
                        <Link to={`/empresas/${e.id_empresa}/editar`} className="sf-btn sf-btn-ghost">
                          <i className="bi bi-pencil" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Paginacao />
          </>
        )}
      </div>
    </div>
  );
}
